import classNames from 'classnames';
import { FC, memo } from 'react';
import { OptionProps } from 'react-select';
import { useStyles } from './ChartSearchOption.styles';
import { UserReporterBlock } from '@shared/components/UserReporterBlock/UserReporterBlock';
import { UserInfo } from '@shared/interfaces/UserInfo';

const ChartSearchOptionComponent: FC<OptionProps> = ({ innerProps, isDisabled, isFocused, data }) => {
  const userData = data as UserInfo;
  const styles = useStyles();

  return !isDisabled ? (
    <div {...innerProps} className={classNames(styles.root, { [styles.isFocused]: isFocused })}>
      <UserReporterBlock
        isDetailInfo
        user={
          userData.position
            ? userData
            : {
                ...userData,
                imageUrl: 'https://ae-happines-zoho-images-storage-staging.s3.us-east-2.amazonaws.com/department.png',
              }
        }
      />
    </div>
  ) : null;
};

export const ChartSearchOption = memo(ChartSearchOptionComponent);
